import UnauthorizedModal from './UnauthorizedModal'
import './UnauthorizedModal.css'
export default UnauthorizedModal
